var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgElectricity = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.552 9.69166V3H19.5454V5.36805L15.8 3.05627L3 10.9566V28.6H28.6V10.9566L26.552 9.69166ZM21.0814 4.536H25.0162V8.74455L21.0814 6.32795V4.536ZM27.064 27.064H4.536V11.8119L15.8 4.86149L27.064 11.8119V27.064Z",
    fill: "#327372"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7293 16.8979L17.5971 14.3892H13.6419L12.6973 18.2727H14.3817L13.5421 22.8422H13.8109L18.9025 16.898L16.7293 16.8979Z",
    fill: "#327372"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgElectricity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/electricity.5b6f313d.svg";
export { ForwardRef as ReactComponent };